import {createTheme} from "@material-ui/core";

export const theme = createTheme({
    welcomePage: {
        height: "60vh"
    }
});